import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Box from '@mui/material/Box';
import { 
  selectResults, 
  // selectUploadedFile, 
  selectConversationId, 
  selectConversationNo, 
  selectTestReport,
  selectUploadedFileName,
  selectCurrentFailureReportSubtitle
} from '../store/features/transmissionSlice';
import { chatWithTransmission } from '../store/services/transmissionService';
// import TransmissionTable from '../components/chatbot/TransmissionTable';
import TransmissionInput from '../components/chatbot/TransmissionInput';
import TransmissionUploadModal from '../components/chatbot/TransmissionUploadModal';
import FailureReport from '../components/transmission/FailureReport';
import AlStarReport from '../components/transmission/AlStarReport';
import ChatbotResults from '../components/transmission/ChatbotResults';

const TransmissionPage = () => {
  const dispatch = useDispatch();
  const results = useSelector(selectResults);
  const conversationId = useSelector(selectConversationId);
  const conversationNo = useSelector(selectConversationNo);
  const testReport = useSelector(selectTestReport);
  const uploadedFileName = useSelector(selectUploadedFileName);
  const currentFailureReportSubtitle = useSelector(selectCurrentFailureReportSubtitle);

  const state = useSelector((state: any) => state);
  // const [showChat, setShowChat] = useState(false);
  const [failReportVisibleColumns, setFailReportVisibleColumns] = useState<string[]>([]);
  const [alstarRecordVisibleColumns, setAlstarRecordVisibleColumns] = useState<string[]>([]);

  useEffect(() => {
    const chatContainer = document.getElementById('transmission-chat-container')
    if (chatContainer) {
      chatContainer.scrollTo({
        top: chatContainer.scrollHeight - chatContainer.clientHeight,
        behavior: 'smooth'
      })
    }
  }, [results])

  // Initialize visible columns when new data arrives
  useEffect(() => {
    results.forEach((result: any) => {
      if (result.answer && Array.isArray(result.answer) && result.answer.length > 0) {
        const answer = result.answer[0];
        
        // Initialize fail report visible columns
        if (answer.response_type === 'table' && answer.response_data?.fail_report) {
          const failReportColumns = answer.response_data.fail_report[0] || [];
          if (failReportColumns.length > 0 && failReportVisibleColumns.length === 0) {
            // Exclude columns: operator, index, type, tag, and units
            const excludedColumns = ['operator', 'index', 'type', 'tag', 'units'];
            const visibleColumnIds = failReportColumns
              .map((column: any, colIndex: number) => ({
                id: `fail_report_${colIndex}`,
                label: column
              }))
              .filter((col: any) => !excludedColumns.some(excluded => 
                col.label.toLowerCase().includes(excluded.toLowerCase())
              ))
              .map((col: any) => col.id);
            
            setFailReportVisibleColumns(visibleColumnIds);
          }
        }
        
        // Initialize alstar record visible columns
        if (answer.response_type === 'table' && answer.response_data?.alstar_record) {
          const alstarRecordColumns = answer.response_data.alstar_record[0] || [];
          if (alstarRecordColumns.length > 0 && alstarRecordVisibleColumns.length === 0) {
            setAlstarRecordVisibleColumns(alstarRecordColumns.map((_: any, colIndex: number) => `alstar_record_${colIndex}`));
          }
        }
      }
    });
  }, [results, failReportVisibleColumns.length, alstarRecordVisibleColumns.length]);

  const handleSendQuestion = async (question: string | null) => {
    if (!question?.trim()) return;
    const fileName = uploadedFileName || testReport;

    try {
      await chatWithTransmission({
        user_prompt: question,
        conversation_no: conversationNo,
        conversation_id: conversationId,
        test_report: fileName.replace('.csv', ''),
        user_email: state.auth.email || state.auth.userId
      }, state, dispatch);
    } catch (error) {
      console.error('Chat failed:', error);
    }
  };

  // const handleUploadSuccess = () => {
  //   setShowChat(true);
  // };

  return (
    <>
      <Box sx={{ 
        height: 'calc(100vh - 5.9em)',
        display: 'flex',
        flexDirection: 'row',
        m: 2,
        gap: 2,
        overflow: 'hidden'
      }}>
        {/* Left side - Reports with scroll */}
        <Box sx={{ 
          flex: 1,
          overflow: 'hidden',
          pr: 1
        }}>
          <FailureReport />
          { currentFailureReportSubtitle && <AlStarReport /> }
        </Box>
        
        {/* Right side - Input at bottom */}
        <Box sx={{ 
          width: '600px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-end',
          height: '80vh',
          overflowY: 'auto'
        }}>
          <ChatbotResults />
          <TransmissionInput handleSendClick={handleSendQuestion} />
        </Box>
      </Box>
      
      {(!results && <TransmissionUploadModal />)}
    </>
  );
}

export default TransmissionPage; 